// Central brand assets + helpers
export const BRAND = {
  name: "Grá",
  tagline: "Irish-rooted art, sound & light",
  wordmark: "https://customer-assets.emergentagent.com/job_irish-atelier/artifacts/7sq2b7hd_IMG_0638%20copy.jpeg",
  knot: "https://customer-assets.emergentagent.com/job_c9cdcf13-5eba-47af-857e-5d780c040273/artifacts/vhm0ts3g_IMG_0640.jpeg",
  heroRedwood: "https://images.unsplash.com/photo-1601052325717-f8140142e64e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxyZWR3b29kJTIwZm9yZXN0JTIwbWlzdHxlbnwwfHx8fDE3ODExODc4NjF8MA&ixlib=rb-4.1.0&q=85",
  cloverTexture: "https://images.unsplash.com/photo-1599056481506-c4975215aff4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxjbG92ZXIlMjBsZWF2ZXMlMjBkYXJrJTIwZ3JlZW58ZW58MHx8fHwxNzgxMTg3ODc3fDA&ixlib=rb-4.1.0&q=85",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Compute display image URL for a product.
// Fallback order: own cover_path → own cover_url → parent album's cover
// → clean Celtic-knot PNG.
export function productImage(product) {
  const fallback = `${API}/brand/knot.png`;
  if (!product) return fallback;
  if (product.cover_path) return `${API}/files/${product.cover_path}`;
  if (product.cover_url) return product.cover_url;
  if (product.album_cover_path) return `${API}/files/${product.album_cover_path}`;
  return fallback;
}

// True if the product actually has an artist-uploaded cover (own or from its album).
export function hasCover(product) {
  return !!(product && (product.cover_path || product.cover_url || product.album_cover_path));
}

export function productAudio(product) {
  if (product?.audio_path) return `${API}/files/${product.audio_path}`;
  return null;
}

export const CATEGORIES = [
  { slug: "music", label: "Music", short: "Sounds of the isle" },
  { slug: "photography", label: "Photography", short: "Captured light" },
  { slug: "drawing", label: "Artwork", short: "Drawings & paintings" },
];
